// Class to handle models that should be one-sided
class OneSidedModelHandler {
    constructor(selector) {
      // Select all models that match the class selector
      this.models = document.querySelectorAll(selector);
      
      // Attach event listeners to each model
      this.models.forEach((modelElement) => {
        modelElement.addEventListener('model-loaded', this.handleModelLoad);
      });
    }
  
    // Method to handle the model-loaded event
    handleModelLoad(evt) {
      const model = evt.detail.model;
      model.traverse((node) => {
        if (node.isMesh) {
          node.material.side = THREE.FrontSide; // Or THREE.BackSide for reverse
        }
      });
    }
  }
  
  // Initialize the OneSidedModelHandler with all models that have the class .one-sided
  document.addEventListener('DOMContentLoaded', () => {
    new OneSidedModelHandler('.one-sided');
  });